import Vue from "vue";
import { BootstrapVue ,BootstrapVueIcons} from "bootstrap-vue";
import config from './custom_config.json'

Vue.use(BootstrapVue, config);
Vue.use(BootstrapVueIcons, config);
